import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { icons } from '../../../assets/icons';
import './index.scss';
import { LoaderComponent } from '../../../helpers/components/loader';
import { useDispatch, useSelector } from 'react-redux';
import { getAllFactures } from '../../../api/redux/slices/Admin';
import Pagination from '../../../helpers/components/Pagination';
import useStableArr from '../../../utils/useStableArr';
import { handleCheck, handleCheckAll } from '../../../utils/checkUtilsAdmin';
import { convertDate } from '../../../helpers/modules';
import { CSVLink } from 'react-csv';

const FacturePage = () => {
    const { factures, checkedList, totalFactures } = useSelector((state) => state.admin);
    const dispatch = useDispatch();
    const params = useParams();

    const [page, setPage] = useState(Number(params.page) || 1);
    const [newArr, setNewArr] = useState([]);
    const [isCheck, setIsCheck] = useState(false);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('accesstoken');

    const stableDispatch = useCallback(() => {
        setLoading(true);
        dispatch(
            getAllFactures({
                token: token,
                search: search,
                page: search ? 1 : page,
            }),
        )
            .unwrap()
            .catch((err) => {
                console.error('Error fetching factures:', err);
            })
            .finally(() => setLoading(false));
    }, [dispatch, page, search, token]);

    useEffect(() => {
        if (token) {
            stableDispatch();
        }
    }, [stableDispatch, search, token]);

    useStableArr(factures, checkedList, setNewArr, setIsCheck);

    const headers = [
        { label: 'NUMÉRO', key: 'reference' },
        { label: 'DATE', key: 'createdAt' },
        { label: 'CLIENT', key: 'client_name' },
        { label: 'SOCIÉTÉ', key: 'company_name' },
        { label: 'TOTAL', key: 'total' },
    ];

    const csvFactureReport = {
        filename: 'Factures.csv',
        data: checkedList.map((facture) => ({
            reference: facture.reference,
            createdAt: convertDate(facture.createdAt, 'DD-MM-YYYY'),
            client_name: facture.client_name,
            company_name: facture.company_name,
            total: facture.total || 0,
        })),
        headers: headers,
    };

    return (
        <div id="billPageAdmin">
            <div className="navbar">
                <div className="left">
                    <div className="nav-search">
                        <input
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            type="search"
                            placeholder="Rechercher ..."
                        />
                        <icons.FiSearch className="searchicon" />
                    </div>
                </div>
                <div className="right">
                    <div className="right-items">
                        <CSVLink {...csvFactureReport} target="blank">
                            <button className="button-nature" title="exporter facture(s)">
                                <icons.BiExport />
                            </button>
                        </CSVLink>
                    </div>
                </div>
            </div>
            <div id="head">
                <div className="title-user">
                    <h1>Factures</h1>
                </div>
            </div>
            <div id="billsContent">
                <table id="bills">
                    <thead>
                        <tr id="titres">
                            <td className="input-check">
                                <input
                                    onChange={() => handleCheckAll(dispatch, newArr, setNewArr, isCheck, setIsCheck)}
                                    checked={isCheck}
                                    type="checkbox"
                                    className="checkbox"
                                />
                            </td>
                            <td>NUMÉRO</td>
                            <td>DATE</td>
                            <td>CLIENT</td>
                            <td>SOCIÉTÉ</td>
                            <td>TOTAL</td>
                            <td>ACTION</td>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7">
                                    <LoaderComponent margin="10%" />
                                </td>
                            </tr>
                        ) : newArr?.length > 0 ? (
                            newArr.map((facture, index) => (
                                <tr className="delivery" key={index}>
                                    <td className="input-check">
                                        <input
                                            onChange={() => handleCheck(dispatch, newArr, setNewArr, facture?._id)}
                                            checked={facture?.checked ?? false}
                                            type="checkbox"
                                            className="checkbox"
                                        />
                                    </td>
                                    <td>{facture.reference}</td>
                                    <td>{convertDate(facture?.createdAt, 'DD-MM-YYYY')}</td>
                                    <td>{facture?.client_name || '-'}</td>
                                    <td>{facture?.company_name || '-'}</td>
                                    <td>{facture?.total != null ? Number(facture?.total).toFixed(2) : 0} DT</td>
                                    <td className="last-delivery-element">
                                        <Link
                                            to={`/admin/facture/${page}/${facture._id}`}
                                            className="link-delivery"
                                        >
                                            <icons.BsEye className="see-delivery" />
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '50px' }}>
                                    Aucune facture trouvée
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination page={page} setPage={setPage} pageLink="/admin/facture/" total={totalFactures} />
        </div>
    );
};

export default FacturePage;